var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMiscellaneous(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 21C0 9.40204 9.40202 0 21 0C32.598 0 42 9.40204 42 21C42 32.598 32.598 42 21 42C9.40202 42 0 32.598 0 21Z",
    fill: "#F4F2FB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_45)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.775 16.3123L21.525 14.3473C21.1864 14.2208 20.8136 14.2208 20.475 14.3473L15.225 16.3123C15.1651 16.3403 15.1074 16.3729 15.0525 16.4098L21 18.6973L26.9475 16.4473C26.894 16.3975 26.8362 16.3523 26.775 16.3123ZM14.25 17.7148V24.2848C14.2505 24.59 14.3442 24.8878 14.5184 25.1384C14.6926 25.389 14.9391 25.5805 15.225 25.6873L20.25 27.5698V20.0173L14.25 17.7073V17.7148ZM27.75 17.7148L21.75 20.0248V27.5698L26.775 25.6873C27.0609 25.5805 27.3074 25.389 27.4816 25.1384C27.6558 24.8878 27.7495 24.59 27.75 24.2848V17.7148Z",
    fill: "#7529D9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_45"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(12 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiscellaneous);
export default __webpack_public_path__ + "static/media/miscellaneous.ebb0da4425cda9f580df9dda2c4cd1d3.svg";
export { ForwardRef as ReactComponent };